import { State, Template, TemplateLayout, TemplateType, User, WorkflowItem } from './interfaces';
import { AccessibilityProfiles, defaultBranding } from '../constants';
import { HeaderOptions, HeaderResponse } from '../base/interfaces/headerInterface';
import { TimeLine } from './interfaces/timeLine';
import { CompanySettings } from './interfaces/companySettings';
import { ProjectSettings } from './interfaces/projectSettings';
import { landingPage } from '../../mockServer/mockData/landingPage';
import { WorkflowSession } from './interfaces/workflowSession';
import { Accessibility } from './interfaces/accessibility';

/** Initial state for StoreProvider */
export const initialState: State = {
  userSessionActive: false,
  isUserInactive: false,
};

export const initialCurrentWorkflowItemState: WorkflowItem = {
  id: '',
  code: '',
  capturesPii: false,
  lastItem: false,
  configuration: '',
  localizedContentMap: [],
  nestedItems: landingPage.nestedItems,
};

export const initialTemplateState: Template = {
  layoutCode: TemplateLayout.TEMPLATE_LAYOUT_01,
  id: '',
  type: TemplateType.EXPERIENCE_LITE,
  status: '',
  companyId: 0,
  firstWorkflowItemId: '0',
  settings: defaultBranding,
};

export const initialCandidateState: User = {
  firstName: '',
  lastName: '',
  email: '',
  candidateId: 0,
};

export const initialTimeLineState: TimeLine = {
  showSpinner: false,
  reverseAnimation: false,
};

export const initialHeaderDetailsState: HeaderResponse = {
  accessibility: '',
  companyName: '',
  language: '',
  showDetails: false,
  showDpn: false,
  showEeo: false,
  showOfccp: false,
  showResearchQuestions: false,
  isVrProject: false,
  isICPEnabled: false,
  isShlAppEnabled: false,
  langGroups: [],
};

export const initialHeaderOptionsState: HeaderOptions = {
  accessibility: AccessibilityProfiles,
  selectedTheme: 0,
  isAssessment: false,
  exit: false,
};

export const initialCompanySettings: CompanySettings = {
  showDpn: false,
  showAppform: false,
  enableOfccp: false,
  showYourResponsiblity: false,
  showEeo: false,
  allowCEBDemographyResearch: false,
  showSimplifiedForm: false,
  faqUrl: '',
  isSocialLoginEnabled: false,
  showLinkedin: false,
  showGoogle: false,
  showFacebook: false,
  enableFairnessDiversity: false,
  enableAccessibility: false,
};

export const initialWorkflowSession: WorkflowSession = {
  active: false,
  autoLogin: false,
  candidateRegistered: false,
  colorContrast: 0,
  companyId: 0,
  companyUserId: 0,
  formStatus: '',
  integrated: false,
  language: '',
  link: '',
  privacyPolicyAccepted: false,
  sessionId: '',
  workflowTemplate: '',
  projectId: 0,
  singleUseLinkId: 0,
};

export const initialProjectSettings: ProjectSettings = {
  showSubsequentStages: false,
  showSurvey: false,
  projectStartDate: '',
  projectEndDate: '',
  registrationStartDate: '',
  registrationEndDate: '',
  projectDeadlinePassed: false,
  registrationClosed: false,
};

export const initialAccessibility: Accessibility = {
  pageChanged: false,
};
